/* eslint-disable camelcase */
import { useQueryClient } from '@tanstack/react-query';

import { RoadmapNode } from '@/api/rest/resources/types/organization';
import { usePostWorkstream } from '@/api/rest/resources/workstreams';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

export const useAddWorkstream = () => {
  const postWorkstreamMutation = usePostWorkstream();
  const queryClient = useQueryClient();
  const organizationId = useOrganizationId();

  const submit = async (
    data: {
      title: string;
      description: string | null;
      plot_groups: string[];
      indicator_products: string[];
      roadmap_nodes: Partial<RoadmapNode>[];
      progress: number | undefined;
    },
    onSuccess?: () => void,
    onError?: (error: Error) => void,
  ) => {
    const { title, description, plot_groups, indicator_products, roadmap_nodes, progress } = data;

    assertIsDefined(title, 'title');
    assertIsDefined(organizationId, 'organizationId');

    await postWorkstreamMutation.mutateAsync(
      {
        pathVariables: { organization_id: organizationId },
        queryParams: undefined,
        bodyData: {
          title,
          description,
          plot_groups: plot_groups ?? [],
          indicator_products: indicator_products ?? [],
          roadmap_nodes: roadmap_nodes ?? [],
          progress: progress ?? undefined,
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['organization', organizationId, 'workstreams'] });
          queryClient.invalidateQueries({
            queryKey: ['organization', { organization_id: organizationId }, 'roadmap-nodes'],
          });
          onSuccess?.();
        },
        onError: (error) => {
          onError?.(error as Error);
        },
      },
    );
  };

  return { submit, isSubmitting: postWorkstreamMutation.isPending };
};
